module.exports = __webpack_public_path__ + "img/exitFull.2f56bd26.svg";